const createArrow = (direction, label, path) => {
  const button = document.createElement("button");
  button.className = `pst-scroll-slider-arrow pst-scroll-slider-${direction}`;
  button.type = "button";
  button.setAttribute("aria-label", label);
  button.innerHTML = `<svg viewBox="0 0 24 24" aria-hidden="true"><path d="${path}" /></svg>`;
  return button;
};

const initMobileSlider = (slider) => {
  const sliderItems = slider.querySelectorAll(".pst-scroll-slider-item");
  if (!sliderItems.length) return () => {};

  const navigation = document.createElement("div");
  navigation.className = "pst-scroll-slider-navigation";
  navigation.setAttribute("aria-label", "Navegación del equipo");

  const previousButton = createArrow("prev", "Anterior", "M15 18l-6-6 6-6");
  const nextButton = createArrow("next", "Siguiente", "M9 6l6 6-6 6");
  navigation.append(previousButton, nextButton);
  slider.insertAdjacentElement("afterend", navigation);

  const getScrollStep = () => {
    const styles = window.getComputedStyle(slider);
    return sliderItems[0].getBoundingClientRect().width + parseFloat(styles.columnGap || styles.gap || 0);
  };

  const updateNavigation = () => {
    const maxScrollLeft = slider.scrollWidth - slider.clientWidth;
    previousButton.disabled = slider.scrollLeft <= 1;
    nextButton.disabled = slider.scrollLeft >= maxScrollLeft - 1;
  };

  const goPrevious = () => slider.scrollBy({ left: -getScrollStep(), behavior: "smooth" });
  const goNext = () => slider.scrollBy({ left: getScrollStep(), behavior: "smooth" });
  let pointerStartX = 0;
  let scrollStartX = 0;

  const startDragging = (event) => {
    if (event.pointerType !== "mouse") return;
    pointerStartX = event.clientX;
    scrollStartX = slider.scrollLeft;
    slider.classList.add("is-dragging");
    slider.setPointerCapture(event.pointerId);
  };

  const drag = (event) => {
    if (!slider.classList.contains("is-dragging")) return;
    slider.scrollLeft = scrollStartX - (event.clientX - pointerStartX);
  };

  const stopDragging = () => slider.classList.remove("is-dragging");

  previousButton.addEventListener("click", goPrevious);
  nextButton.addEventListener("click", goNext);
  slider.addEventListener("pointerdown", startDragging);
  slider.addEventListener("pointermove", drag);
  slider.addEventListener("pointerup", stopDragging);
  slider.addEventListener("pointercancel", stopDragging);
  slider.addEventListener("scroll", updateNavigation, { passive: true });
  window.addEventListener("resize", updateNavigation);
  updateNavigation();

  return () => {
    previousButton.removeEventListener("click", goPrevious);
    nextButton.removeEventListener("click", goNext);
    slider.removeEventListener("pointerdown", startDragging);
    slider.removeEventListener("pointermove", drag);
    slider.removeEventListener("pointerup", stopDragging);
    slider.removeEventListener("pointercancel", stopDragging);
    slider.removeEventListener("scroll", updateNavigation);
    window.removeEventListener("resize", updateNavigation);
    slider.classList.remove("is-dragging");
    slider.scrollLeft = 0;
    navigation.remove();
  };
};

const initDesktopSlider = (slider) => {
  if (!window.gsap || !window.ScrollTrigger) return () => {};

  const pinTarget = slider.closest(".pst-scroll-slider-trigger") || slider;
  const sliderItems = slider.querySelectorAll(".pst-scroll-slider-item");
  if (!sliderItems.length) return () => {};

  const getMaxX = () => Math.max(slider.scrollWidth - slider.clientWidth + 100, 0);
  window.gsap.set(pinTarget, { zIndex: 2 });

  const tween = window.gsap.to(sliderItems, {
    ease: "none",
    force3D: true,
    x: () => -getMaxX(),
    scrollTrigger: {
      trigger: pinTarget,
      pin: pinTarget,
      pinSpacing: true,
      start: "top top",
      end: () => "+=" + getMaxX(),
      scrub: 1,
      invalidateOnRefresh: true,
      markers: false,
    },
  });

  return () => {
    if (tween.scrollTrigger) tween.scrollTrigger.kill();
    tween.kill();
    window.gsap.set(sliderItems, { clearProps: "transform" });
    window.gsap.set(pinTarget, { clearProps: "zIndex" });
  };
};

const init = () => {
  const sliders = document.querySelectorAll(".pst-scroll-slider");
  if (!sliders.length) return;

  sliders.forEach((slider) => {
    if (slider.dataset.responsiveSliderInitialized === "true") return;
    slider.dataset.responsiveSliderInitialized = "true";

    const mobileQuery = window.matchMedia("(max-width: 1023px)");
    let cleanup = () => {};

    const applyMode = () => {
      cleanup();
      cleanup = mobileQuery.matches ? initMobileSlider(slider) : initDesktopSlider(slider);
      window.ScrollTrigger?.refresh();
    };

    mobileQuery.addEventListener("change", applyMode);
    applyMode();
  });
};

export { init };
